import PropTypes from 'prop-types';
import React from 'react';
import Validator from 'mixins/validator';
import Resetter from 'mixins/resetter';
import { Button } from 'react-toolbox/lib/button';
import { connect } from 'react-redux';
import ComposeWindow from 'components/ComposeWindow';
import TextArea from 'components/TextArea';
import S from 'components/ComposeWindow/styles.scss';
import { addEventToEmployee, addEventToInstaller, addEventToEstimator, clearValidation } from 'actionCreators';

class EmployableHistoryNoteModal extends Resetter(Validator(React.Component)) {
  static DEFAULT_STATE = {
    note: '',
    errors: {},
  }
  static VALIDATIONS = { note: true }

  handleSubmit = () => {
    const note = this.textAreaComponentRef.textAreaRef.value;
    this.setState({ note }, () => {
      if (!this.validate()) return;
      const noteProps = {
        name: 'Note',
        kind: 'note',
        data: { note },
      };
      this.callAddEvent(noteProps);
    });
  }

  callAddEvent = (noteProps) => {
    const employableId = this.props.employable.id;
    let addEventToEmployable;
    switch (this.props.employableType) {
      case 'employee':
        addEventToEmployable = this.props.addEventToEmployee;
        break;
      case 'installer':
        addEventToEmployable = this.props.addEventToInstaller;
        break;
      case 'estimator':
        addEventToEmployable = this.props.addEventToEstimator;
        break;
      default:
    }
    addEventToEmployable(employableId, noteProps).then(() => {
      this.handleClose();
    }).catch(() => {}); // catching this to avoid console warnings...
  }

  handleClose = () => {
    this.props.clearValidation();
    this.props.closeNoteModal();
  }

  render = () => {
    const { errors } = this.state;
    const active = this.props.active;

    return (<ComposeWindow
      active={active}
      title="Add Note"
      onClose={this.handleClose}
    >
      <TextArea
        label="Notes *"
        defaultValue=""
        className={S.compose}
        errors={errors.note}
        autoFocus
        ref={(comp) => { this.textAreaComponentRef = comp; }}
      />
      <div className={S.actions}>
        <Button
          label="Add Note"
          primary flat ripple
          className={S.submit}
          onClick={this.handleSubmit}
        />
      </div>
    </ComposeWindow>);
  }
}


EmployableHistoryNoteModal.propTypes = {
  active: PropTypes.bool.isRequired,
  addEventToEmployee: PropTypes.func,
  addEventToInstaller: PropTypes.func,
  addEventToEstimator: PropTypes.func,
  clearValidation: PropTypes.func.isRequired,
  closeNoteModal: PropTypes.func.isRequired,
  employable: PropTypes.object.isRequired,
};


EmployableHistoryNoteModal.defaultProps = { active: false };

export default connect(null, {
  addEventToEmployee,
  addEventToInstaller,
  addEventToEstimator,
  clearValidation,
})(EmployableHistoryNoteModal);



// WEBPACK FOOTER //
// ./client/app/shared/components/EmployableHistory/employableHistoryNoteModal.jsx